import { withStyles } from '@material-ui/core/styles'
import React from 'react'
import styles from './styles'
import { useDispatch, useSelector } from 'react-redux'
import { ShareViewHeader, ShareView, EmbedView } from './components'

const SharePopover = props => {
  const { classes, activeItem } = props
  const dispatch = useDispatch()
  const collection = useSelector(state => state.collection.collection)

  // Map activeItem to view names
  const viewMap = {
    url: 'share-collection',
    embed: 'embed-collection',
  }

  const currentView = viewMap[activeItem] || 'share-collection'

  const collectionComponents = [
    {
      component: <ShareView entity={collection} dispatch={dispatch} />,
      onView: currentView === 'share-collection',
    },
    {
      component: <EmbedView entity={collection} />,
      onView: currentView === 'embed-collection',
    },
  ]

  return (
    <div className={classes.content}>
      <div
        className={`${classes.content__components} ${classes.shareViewContent}`}
      >
        <ShareViewHeader view={currentView} />
        {collectionComponents.map(
          (component, index) =>
            component.onView && <div key={index}>{component.component}</div>,
        )}
      </div>
    </div>
  )
}

export default withStyles(styles)(SharePopover)
